import './HouseDetailPage.css';

// Import images
import clubImage1 from './assets/news/news1.jpg';
import clubImage2 from './assets/news/news3.jpg';
import clubImage3 from './assets/news/news4.jpg';
import clubImage4 from './assets/news/news6.jpg';
import clubImage5 from './assets/news/news7.jpg';

function HouseDetailPage({ houseName, onNavigate }) {
  const houseData = {
    'house-house-of-courage': {
      name: 'House of Courage',
      motto: 'Courage Unlocks Dreams',
      color: '#dc2626',
      colorLight: '#fee2e2',
      icon: 'fa-shield',
      image: clubImage1,
      description: 'House of Courage embodies the spirit of bravery, determination, and fearless leadership. Our members are bold explorers who embrace challenges with unwavering confidence and inspire others through their courageous actions.',
      values: [
        'Brave leadership',
        'Fearless determination',
        'Resilience and strength',
        'Bold innovation',
        'Inspiring others'
      ],
      achievements: [
        'Leadership Excellence Award 2024',
        'Courage in Action Recognition',
        'Sports Championship Winners',
        'Innovation Challenge Champions'
      ],
      members: 'Approximately 180 students across all levels',
      houseLeader: 'Mr. James Wilson',
      activities: [
        'Leadership development programs',
        'Courage workshops and seminars',
        'Sports training and competitions',
        'Motivational speaking events',
        'Challenge and adventure activities'
      ],
      highlights: 'House of Courage is known for fostering bold leaders who take risks, embrace challenges, and inspire their peers. Our house culture celebrates bravery, determination, and the courage to make a difference.'
    },
    'house-house-of-love': {
      name: 'House of Love',
      motto: 'Love Guides Us Forward',
      color: '#ec4899',
      colorLight: '#fce7f3',
      icon: 'fa-heart',
      image: clubImage2,
      description: 'House of Love stands for compassion, kindness, and genuine care for one another. Our members create a nurturing environment where everyone feels valued, supported, and celebrated for who they are.',
      values: [
        'Compassion and empathy',
        'Genuine care',
        'Inclusivity and belonging',
        'Emotional support',
        'Community love'
      ],
      achievements: [
        'Community Service Excellence 2024',
        'Kindness Award',
        'Peer Support Recognition',
        'Inclusion and Diversity Prize'
      ],
      members: 'Approximately 175 students across all levels',
      houseLeader: 'Ms. Sarah Chen',
      activities: [
        'Community service projects',
        'Peer mentoring programs',
        'Wellness and support circles',
        'Inclusive social events',
        'Charity and fundraising initiatives'
      ],
      highlights: 'House of Love creates a warm, welcoming community where love and compassion are the foundation. Members actively support each other and extend genuine care to the broader school community.'
    },
    'house-house-of-hope': {
      name: 'House of Hope',
      motto: 'Hope Lights the Way',
      color: '#eab308',
      colorLight: '#fef3c7',
      icon: 'fa-lightbulb',
      image: clubImage3,
      description: 'House of Hope inspires optimism, positivity, and belief in a brighter future. Our members are visionaries who see possibilities, encourage others, and work together to create meaningful change and lasting impact.',
      values: [
        'Optimism and positivity',
        'Vision for the future',
        'Inspiring hope',
        'Collaborative growth',
        'Meaningful impact'
      ],
      achievements: [
        'Vision and Innovation Award 2024',
        'Positive Impact Recognition',
        'Future Leaders Prize',
        'Inspiration and Motivation Award'
      ],
      members: 'Approximately 180 students across all levels',
      houseLeader: 'Mr. David Martinez',
      activities: [
        'Vision and goal-setting workshops',
        'Inspirational speaker series',
        'Future leaders development',
        'Positive change initiatives',
        'Hope and wellness programs'
      ],
      highlights: 'House of Hope is the beacon of optimism and possibility. Our members inspire others through their positive outlook, visionary thinking, and commitment to creating a better tomorrow for everyone.'
    },
    'house-house-of-faith': {
      name: 'House of Faith',
      motto: 'Faith Guides Our Path',
      color: '#f97316',
      colorLight: '#ffedd5',
      icon: 'fa-cross',
      image: clubImage4,
      description: 'House of Faith is built on trust, belief, and unwavering commitment to our values. Our members demonstrate integrity, loyalty, and steadfast dedication to supporting one another and upholding our shared principles.',
      values: [
        'Trust and integrity',
        'Loyalty and commitment',
        'Steadfast values',
        'Belief in each other',
        'Principled action'
      ],
      achievements: [
        'Character Excellence Award 2024',
        'Integrity and Trust Recognition',
        'Loyalty Award',
        'Values Leadership Prize'
      ],
      members: 'Approximately 170 students across all levels',
      houseLeader: 'Ms. Emily Rodriguez',
      activities: [
        'Character development programs',
        'Values and ethics discussions',
        'Trust-building activities',
        'Integrity workshops',
        'Community commitment projects'
      ],
      highlights: 'House of Faith cultivates a culture of trust, integrity, and unwavering commitment. Members are encouraged to believe in themselves and each other, and to act with principled conviction in all they do.'
    },
    'house-house-of-peace': {
      name: 'House of Peace',
      motto: 'Peace Leads Us Forward',
      color: '#22c55e',
      colorLight: '#dcfce7',
      icon: 'fa-dove',
      image: clubImage5,
      description: 'House of Peace promotes harmony, understanding, and peaceful collaboration. Our members are peacemakers who bridge differences, foster unity, and create an environment where everyone can thrive in tranquility and mutual respect.',
      values: [
        'Harmony and balance',
        'Understanding and empathy',
        'Peaceful collaboration',
        'Unity and respect',
        'Conflict resolution'
      ],
      achievements: [
        'Peace and Harmony Award 2024',
        'Conflict Resolution Excellence',
        'Unity and Understanding Prize',
        'Community Harmony Recognition'
      ],
      members: 'Approximately 175 students across all levels',
      houseLeader: 'Mr. Christopher Lee',
      activities: [
        'Conflict resolution workshops',
        'Meditation and mindfulness sessions',
        'Peacemaking initiatives',
        'Unity and understanding events',
        'Harmony and wellness programs'
      ],
      highlights: 'House of Peace is the sanctuary of harmony and understanding. Our members work tirelessly to bridge differences, foster unity, and create a peaceful environment where all can flourish together.'
    }
  };

  const house = houseData[houseName];

  if (!house) {
    return (
      <div className="house-detail-error">
        <h2>House not found</h2>
        <p>The house you're looking for doesn't exist. Please go back to Student Life.</p>
        <button onClick={() => onNavigate('student-life', 'house-system')}>Back to Student Life</button>
      </div>
    );
  }

  return (
    <section className="house-detail-page">
      {/* Hero Section with Image */}
      <section className="house-detail-hero" style={{ backgroundColor: house.color }}>
        <div className="house-detail-hero-pattern" />
        <div className="house-detail-hero-image">
          <img src={house.image} alt={house.name} />
          <div className="house-detail-hero-overlay" />
        </div>
        <div className="house-detail-hero-content">
          <button className="house-detail-back-btn" onClick={() => onNavigate('student-life', 'house-system')}>
            <i className="fas fa-arrow-left" /> Back
          </button>
          <div className="house-detail-hero-icon">
            <i className={`fas ${house.icon}`} />
          </div>
          <h1 className="house-detail-hero-title">{house.name}</h1>
          <p className="house-detail-hero-motto">"{house.motto}"</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="house-detail-main">
        {/* About Section */}
        <div className="house-detail-section">
          <div className="house-detail-section-header">
            <h2>About {house.name}</h2>
            <div className="house-detail-section-line" style={{ backgroundColor: house.color }} />
          </div>
          <p className="house-detail-description">{house.description}</p>
          <div className="house-detail-highlight-box" style={{ backgroundColor: house.colorLight, borderLeftColor: house.color }}>
            <i className={`fas ${house.icon}`} style={{ color: house.color }} />
            <p>{house.highlights}</p>
          </div>
        </div>

        {/* Quick Info Cards */}
        <div className="house-detail-info-grid">
          <div className="house-detail-info-card">
            <div className="house-detail-info-icon" style={{ backgroundColor: house.colorLight, color: house.color }}>
              <i className="fas fa-users" />
            </div>
            <h4>Members</h4>
            <p>{house.members}</p>
          </div>
          <div className="house-detail-info-card">
            <div className="house-detail-info-icon" style={{ backgroundColor: house.colorLight, color: house.color }}>
              <i className="fas fa-user-tie" />
            </div>
            <h4>House Leader</h4>
            <p>{house.houseLeader}</p>
          </div>
          <div className="house-detail-info-card">
            <div className="house-detail-info-icon" style={{ backgroundColor: house.colorLight, color: house.color }}>
              <i className="fas fa-star" />
            </div>
            <h4>Core Values</h4>
            <p>{house.values.length} Values</p>
          </div>
        </div>

        {/* Core Values Section */}
        <div className="house-detail-section">
          <div className="house-detail-section-header">
            <h2>Core Values</h2>
            <div className="house-detail-section-line" style={{ backgroundColor: house.color }} />
          </div>
          <div className="house-detail-values-grid">
            {house.values.map((value, index) => (
              <div key={value} className="house-detail-value-card" style={{ borderTopColor: house.color }}>
                <div className="house-detail-value-badge" style={{ backgroundColor: house.color }}>
                  {index + 1}
                </div>
                <h4>{value}</h4>
              </div>
            ))}
          </div>
        </div>

        {/* Activities Section */}
        <div className="house-detail-section">
          <div className="house-detail-section-header">
            <h2>House Activities</h2>
            <div className="house-detail-section-line" style={{ backgroundColor: house.color }} />
          </div>
          <div className="house-detail-activities-grid">
            {house.activities.map((activity, index) => (
              <div key={activity} className="house-detail-activity-card">
                <div className="house-detail-activity-number" style={{ backgroundColor: house.color }}>
                  {index + 1}
                </div>
                <div className="house-detail-activity-content">
                  <p>{activity}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Achievements Section */}
        <div className="house-detail-section">
          <div className="house-detail-section-header">
            <h2>Achievements & Recognition</h2>
            <div className="house-detail-section-line" style={{ backgroundColor: house.color }} />
          </div>
          <div className="house-detail-achievements-grid">
            {house.achievements.map((achievement) => (
              <div key={achievement} className="house-detail-achievement-card" style={{ backgroundColor: house.colorLight, borderLeftColor: house.color }}>
                <div className="house-detail-achievement-icon" style={{ color: house.color }}>
                  <i className="fas fa-trophy" />
                </div>
                <p>{achievement}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="house-detail-cta" style={{ backgroundColor: house.color }}>
        <div className="house-detail-cta-content">
          <h2>Join {house.name}</h2>
          <p>Be part of a community that values {house.motto.toLowerCase()}</p>
          <button className="house-detail-cta-btn" onClick={() => onNavigate('student-life', 'house-system')}>
            Explore Other Houses <i className="fas fa-arrow-right" />
          </button>
        </div>
      </section>
    </section>
  );
}

export default HouseDetailPage;
